import { Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { ErrorHandlerService } from "@youm-front/utils/error-handler";
import { tap } from "rxjs/operators";

@Injectable()
export class ConsoleEffects {
  constructor(private readonly errorHandlerService: ErrorHandlerService) {}

  errorHandler$ = createEffect(
    // eslint-disable-next-line no-console
    () => this.errorHandlerService.error$.pipe(tap((_) => console.error(_))),
    { dispatch: false }
  );
}
